import { DimensionStyling } from 'shared/styling';
import styled from 'styled-components';

export const ModalWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px;
  gap: 20px;
  text-align: center;

  box-sizing: border-box;
  background: #ffffff;
  box-shadow: 0px 2px 14px rgba(194, 207, 221, 0.5);
  border-radius: 10px;

  ${DimensionStyling({
    maxWidth: '730px',
    width: '100%',
    maxHeight: '90svh',
    height: 'max-content',
  })};
`;
